import { render, staticRenderFns } from "./audioList.vue?vue&type=template&id=0d183c66"
import script from "./audioList.vue?vue&type=script&lang=js"
export * from "./audioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports